<template>
  <div class="container-table-list" :class="{ 'right-read': $i18n.locale === 'ar' }">
    <div class="list-fields">
      <div class="field field1">{{ $t('lang.wd.phAccount') }}</div>
      <div class="field field2">
        {{ $t('lang.dl.income') }}
        <img :src="getMatchImg('beans')" />
      </div>
      <div class="field field3">
        {{ $t('lang.dl.commission') }}
        <img :src="getMatchImg('beans')" />
      </div>
    </div>

    <div class="list-fields" v-for="(item, index) in data" :key="item.index">
      <div class="bd-field field1 user-info">
        <div class="name-id">
          <div class="name-wrap">
            <span>{{ item.nickname }}</span>
            <img :src="item.locationFlag | imgPath" />
          </div>
          <div class="id-wrap" @click="handleCopy(item.presentId, $t('lang.msgCopySuccss'))">
            ID:{{ item.presentId }}
            <img src="@/views/P2_Page/Invite/images/copy-gray.png" alt="" />
          </div>
        </div>
      </div>
      <div class="bd-field field2">{{ item.hostIncome }}</div>
      <div class="bd-field field3">{{ item.hostIncomeCommission }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: []
  }
}
</script>
<style lang="scss" scoped>
.container-table-list {
  width: 100%;
  min-height: 500px;
  padding: 0 16px;
  .list-fields {
    width: 100%;
    display: flex;
    padding: 0 12px;
    margin: 14px 0;
    .field {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 14px;
      color: #b2b2b2;
      text-align: center;
      img {
        width: 13px;
        height: 13px;
        vertical-align: middle;
      }
    }
    .field1 {
      flex: 1;
    }
    .field2 {
      flex: 1;
    }
    .field3 {
      flex: 1;
    }

    .bd-field {
      min-height: 36px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      text-align: center;
      &.field2 {
        line-height: 36px;
      }
      &.field3 {
        line-height: 36px;
      }
    }
    .user-info {
      display: flex;
      .name-id {
        text-align: left;
        padding-left: 10px;
        .name-wrap {
          max-width: 98px;
          font-size: 0;
          text-align: left;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: left;
          span {
            max-width: 80px;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 15px;
            color: #333333;
            text-align: left;
            overflow: hidden;
            white-space: nowrap;
          }
          img {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-left: 5px;
            margin-top: 2px;
          }
        }
        .id-wrap {
          display: inline-block;
          margin-top: 4px;
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 12px;
          color: #b2b2b2;
          text-align: left;
          position: relative;
          word-break: break-all;
          img {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            position: absolute;
            top: 50%;
            right: -16px;
            margin-top: -6px;
          }
        }
      }
    }
  }
}
</style>
